"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var BonusTemplatesCurrencyConfigListCtl = /** @class */ (function (_super) {
    __extends(BonusTemplatesCurrencyConfigListCtl, _super);
    function BonusTemplatesCurrencyConfigListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_bonus_template_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_template_id; });
        _this.dk_bonus_template_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_template_title; });
        _this.dk_app_currency_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_id; });
        _this.dk_app_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_title; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_is_default = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_default; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this._errDialog = errDialog;
        return _this;
    }
    BonusTemplatesCurrencyConfigListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            currency_filter: [],
            total: 0
        };
    };
    BonusTemplatesCurrencyConfigListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "bonus template with id [" + id + "] not found !";
    };
    BonusTemplatesCurrencyConfigListCtl.prototype.LoadData = function (bonusTemplateId, onDone) {
        var _this = this;
        webAApi_1.ListBonusTemplateCurrencyConfigByBonusTemplateIdGet.exec({
            bonus_template_id: bonusTemplateId,
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            //
            _this.DATA.currency_filter = [];
            var currency_filter_map = new Map();
            //
            for (var i = 0; i < resp.list.length; i++) {
                if (!currency_filter_map.get(resp.list[i].app_currency_title)) {
                    _this.DATA.currency_filter.push({ text: resp.list[i].app_currency_title, value: resp.list[i].app_currency_title });
                    currency_filter_map.set(resp.list[i].app_currency_title, resp.list[i].app_currency_title);
                }
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    bonus_template_id: resp.list[i].bonus_template_id,
                    bonus_template_title: resp.list[i].bonus_template_title,
                    app_currency_id: resp.list[i].app_currency_id,
                    app_currency_title: resp.list[i].app_currency_title,
                    is_default: resp.list[i].is_default,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    description: resp.list[i].description
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BonusTemplatesCurrencyConfigListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBonusTemplateCurrencyConfig.exec({
            data: {
                bonus_template_id: data.bonus_template_id,
                app_currency_id: data.app_currency_id,
                is_default: data.is_default,
                description: data.description
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_changed: moment(resp.date_changed_uts_ms).utc(false),
                date_added: moment(resp.date_added_uts_ms).utc(false),
                app_currency_id: data.app_currency_id,
                app_currency_title: resp.app_currency_title,
                bonus_template_id: data.bonus_template_id,
                bonus_template_title: resp.bonus_template_title,
                is_default: data.is_default,
                description: data.description
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BonusTemplatesCurrencyConfigListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditBonusTemplateCurrencyConfig.exec({
                data: {
                    bonus_template_config_id: data.key,
                    app_currency_id: data.app_currency_id,
                    is_default: data.is_default,
                    description: data.description
                }
            }, function (resp) {
                _tmp.app_currency_id = data.app_currency_id;
                _tmp.app_currency_title = resp.app_currency_title;
                _tmp.is_default = data.is_default;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.description = data.description;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BonusTemplatesCurrencyConfigListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    BonusTemplatesCurrencyConfigListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBonusTemplateCurrencyConfig.exec({
                data: {
                    bonus_template_currency_config_id: key
                }
            }, function (resp) {
                _this.RemoveItem(key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BonusTemplatesCurrencyConfigListCtl.prototype.doCloneData = function (key, appCurrencyId, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoCloneBonusCurrencyConfig.exec({
                data: {
                    bonus_template_currency_id: key,
                    app_currency_id: appCurrencyId
                }
            }, function (resp) {
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BonusTemplatesCurrencyConfigListCtl.prototype.SetIsDefault = function (key, IsDefault, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetBonusTemplateCurrencyConfigIsDefault.exec({
                data: {
                    bonus_template_currency_config_id: key,
                    is_default: IsDefault
                }
            }, function (resp) {
                if (IsDefault) {
                    for (var i = 0; i < _this.DATA.data.length; i++) {
                        _this.DATA.data[i].is_default = false;
                    }
                }
                _tmp.is_default = IsDefault;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return BonusTemplatesCurrencyConfigListCtl;
}(BaseController_1.BaseController));
exports.BonusTemplatesCurrencyConfigListCtl = BonusTemplatesCurrencyConfigListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_bonus_templates/ctl/BonusTemplateCurrencyConfigListCtl.ts
// module id = 1010
// module chunks = 0